var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('OmtLayoutHeaderFooter',{attrs:{"footer":_vm.showFooter,"bg":['none', '#F6F6F9'],"header":{ titleLabel: _vm.title }}},[_c('omint-slider',[_c('OmtGrid',[_c('OmtRow',[_c('router-view')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }